import CityService from '@/services/city.service'

export const getCityList = ({ commit }, query) => {
  return CityService.getList(query).then((response) => {
    commit('setCities', response.data)
  })
}
